import { ROLE_LIMIT, USER_ROLE } from '@socialive/common';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectRolesLicensingData } from '~/store';

const RoleUsage = ({ role }) => {
  const rolesLicense = useSelector(selectRolesLicensingData);
  const roleInfo = rolesLicense[role];

  const usage = useMemo(() => {
    if (roleInfo.limit === ROLE_LIMIT.UNLIMITED) return 'Unlimited';
    if (roleInfo.limit === 0 && roleInfo.current === 0) return 'N/A';

    return `${roleInfo.current}/${roleInfo.limit} used`;
  }, [roleInfo]);

  return (
    <div className="mb-4">
      <div className="capitalize text-new-md headline-text text-light-copy-primary mb-1">{role.toLowerCase()}</div>
      <div className="text-new-md paragraph-text text-light-copy-secondary">{usage}</div>
    </div>
  );
};

RoleUsage.propTypes = {
  role: PropTypes.oneOf([
    USER_ROLE.GUEST,
    USER_ROLE.CONTRIBUTOR,
    USER_ROLE.CREATOR,
    USER_ROLE.PRODUCER,
    USER_ROLE.BROADCASTER,
    USER_ROLE.ADMIN,
  ]).isRequired,
};

export default RoleUsage;
